import api from '../api'

export default {
    namespaced: true,
    state: {
        clubChangePay: {
            beanList: [],
            total: 0,
        },
        clubCreate: {
            beanList: [],
            total: 0,
        },
        tribeCreate: {
            beanList: [],
            total: 0,
        },
        tribeJoin: {
            beanList: [],
            total: 0,
        }
    },
    mutations: {
        setStateClubChangePay(state, info) {
            state.clubChangePay = info;

        },
        setStateClubCreate(state, info) {
            state.clubCreate = info;
        },
        setStateTribeCreate(state, info) {
            state.tribeCreate = info;
        },
        setStateTribeJoin(state, info) {
            state.tribeJoin = info;
        }
    },
    actions: {
        // 俱乐部更改交易模式申请
        getClubChangePayList({commit}, page) {
            return api.post('/messages/clubChangePay', '俱乐部更改交易模式申请 - 消息列表', {
                page
            }).then(res => {
                commit('setStateClubChangePay', res.data)
            })
        },
        approveClubChangePay(store, msgId) {
            return api.post('/messages/clubChangePay/approve', '俱乐部更改交易模式申请 - 同意', {msgId})
        },
        rejectClubChangePay(store, msgId) {
            return api.post('/messages/clubChangePay/reject', '俱乐部更改交易模式申请 - 拒绝', {msgId})
        },

        // 俱乐部创建申请
        getClubCreateList({commit}, page) {
            return api.post('/messages/clubCreate', '俱乐部创建申请 - 消息列表', {
                page
            }).then(res => {
                commit('setStateClubCreate', res.data)
            })
        },
        approveClubCreate(store, params) {
            return api.post('/messages/clubCreate/approve', '俱乐部创建申请 - 同意', params)
        },
        rejectClubCreate(store, msgId) {
            return api.post('/messages/clubCreate/reject', '俱乐部创建申请 - 拒绝', {msgId})
        },

        // 联盟创建申请
        getTribeCreateList({commit}, page) {
            return api.post('/messages/tribeCreate', '联盟创建申请 - 消息列表', {
                page
            }).then(res => {
                commit('setStateTribeCreate', res.data)
            })
        },
        approveTribeCreate(store, params) {
            return api.post('/messages/tribeCreate/approve', '联盟创建申请 - 同意', params)
        },
        rejectTribeCreate(store, msgId) {
            return api.post('/messages/tribeCreate/reject', '联盟创建申请 - 拒绝', {msgId})
        },

        // 联盟加入申请
        getTribeJoinList({commit}, page) {
            return api.post('/messages/tribeJoin', '联盟加入申请 - 消息列表', {
                page
            }).then(res => {
                commit('setStateTribeJoin', res.data)

            })
        },
        approveTribeJoin(store, msgId) {
            return api.post('/messages/tribeJoin/approve', '联盟加入申请 - 同意', {msgId})
        },
        rejectTribeJoin(store, msgId) {
            return api.post('/messages/tribeJoin/reject', '联盟加入申请 - 拒绝', {msgId})
        },
    }
}